import gql from "graphql-tag";

export const DOCUMENT_TEMPLATES = gql`
  query DocumentTemplates(
    $skip: Int
    $take: Int
    $where: DocumentTemplateWhereInput
    $orderBy: [DocumentTemplateWhereInput]
  ) {
    documentTemplates(
      skip: $skip
      take: $take
      where: $where
      orderBy: $orderBy
    ) {
      data {
        id
        name
        s3Key
        status
        createdDate
      }
      count
    }
  }
`;

export const DOCUMENT_TEMPLATE = gql`
  query DocumentTemplate($where: DocumentTemplateWhereInput) {
    documentTemplate(where: $where) {
      id
      name
      s3Key
      status
      anchors
      anchorMappings
      createdDate
    }
  }
`;

export const DOCUMENT_PAYLOAD_SCHEMA = gql`
  query DocumentPayloadSchema($where: SubscriptionWhereInput!) {
    documentPayloadSchema(where: $where) {
      version
      paths {
        path
        type
        sample
      }
      payload
    }
  }
`;

const documentTemplates = {
  DOCUMENT_TEMPLATES,
  DOCUMENT_TEMPLATE,
  DOCUMENT_PAYLOAD_SCHEMA,
};

export default documentTemplates;
